import type { CameraTrap } from "@typings/entities/devices/cameraTrap";

export interface CameraTrapWithLabels extends CameraTrap {
  location: string;
}

export function prepareCameraTrapsTable(
  cameraTraps: CameraTrap[],
): CameraTrapWithLabels[] {
  return cameraTraps.map((cameraTrap) => ({
    ...cameraTrap,
    location:
      cameraTrap.latitude != null && cameraTrap.longitude != null
        ? `Lat: ${cameraTrap.latitude}, Long: ${cameraTrap.longitude}`
        : "",
  }));
}
